<cm-icon class="close" name="close-thin" (click)="closeClick.emit()"></cm-icon>
<div class="popup-wrapper">
    <img class="logo" src="/assets/images/certemy-white-logo.svg" alt="certemy logo" />
    <p class="text">Automate Licence Verification & Compliance</p>
    <a [href]="link" class="link-button" target="_blank" (click)="closeClick.emit()">Learn More</a>
</div>
